import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=c85149d8&"
import script from "./LoginFooter.vue?vue&type=script&lang=js&"
export * from "./LoginFooter.vue?vue&type=script&lang=js&"
import style0 from "./LoginFooter.vue?vue&type=style&index=0&id=c85149d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports